export default __webpack_public_path__ + "static/media/gallery-1.6258a442.jpg";